// Eager slim slice of the marketplace function barrel (#16).
//
// The full `./index.js` barrel is a single ~116KB module (catalog hydration,
// community feed, install dispatch, filter/URL sync, …) that the unified shell
// dragged into its EAGER chunk via
// `import * from '../marketplace/functions/index.js'` in workspace/context.js.
//
// Marketplace is now a lazy sub-app: the `/marketplace*` routes fold the FULL
// marketplace context (components + functions) into the live shell context on
// first mount (workspace/pages/index.js → lazySharedLib). So the eager chunk
// only needs the marketplace functions the shell references BEFORE any
// marketplace route mounts.
//
// A grep of the whole eager surface (workspace app.js/pages/components/
// functions, shared/**, preview) found exactly ONE such reference:
//   • closeInstallModal — app.js's shell-root install-modal watcher calls
//     `el.call('closeInstallModal', s.root)` in its onCancel (~app.js:1160).
// Every other marketplace function (marketplaceHostOf, submitInstallModal,
// selectItemFresh, hydrate*, dispatch*, …) is only ever el.call'd from a
// marketplace-mounted component, i.e. AFTER a `/marketplace*` fold registers
// it — so it rides the lazy chunk, not this one.
//
// marketplace/package.json has no `sideEffects: false`, so re-exporting through
// `./index.js` would NOT tree-shake (it would evaluate the whole barrel). The
// key below is therefore `export *`-ed from its light SOURCE file directly.
export * from './installModalControls.js'

// The Workspace Presets data layer (wt/presets CONTRACT §5) — the second eager
// reference. The new-account wizard (packages/workspace) calls
// workspacePresetsLoad / workspacePresetsFeatured / workspacePresetByKey /
// workspacePresetApplied / workspacePresetCanApply / workspacePresetApply /
// workspacePresetText on the HOME route, before any /marketplace fold. One
// light, self-contained module (no imports), so it adds only its own source to
// the eager chunk.
export * from './workspacePresets.js'

// THE App Store item id and link (appStoreItemId / appStoreItemLink) — the
// third eager reference. The shell builds a link to an app's App Store page
// before any /marketplace fold: the /add-app catalog card's Details link, the
// search suggestion's App Store row and the apps hub's Manage (workspace), an
// AI card's App Store link (canvas canvasAnswerStoreLink). One light,
// self-contained module (no imports); the link reaches the id through its
// element, so both names ride here.
export * from './appStoreItemLink.js'
